import type { NoteWithUnitsSectionResponse } from '../../../../../resources/@types/uccSchema';

export const countTotalNotes = (sections: NoteWithUnitsSectionResponse[]) =>
  sections
    .map((section) => section.units)
    .flat()
    .map((unit) => unit.notes.length)
    .reduce((sum, noteCount) => sum + noteCount, 0);
